module.exports = __webpack_public_path__ + "static/media/home_active.22ff4b22.svg";